(() => {
  function publish(name, details) {
    const query = String(details.search_term || '').trim().slice(0, 100);
    if (!query || /@|(?:\+?\d[\s().-]*){7,}/.test(query)) return;
    const data = {...details, search_term: query, theme_mode: window.Shopify?.theme?.role === 'main' ? 'storefront' : 'preview'};
    try { Promise.resolve(window.Shopify?.analytics?.publish(`pdil_${name}`, data)).catch(() => {}); } catch (_) {}
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    const predictive = link?.closest('predictive-search');
    if (predictive && link.closest('[data-predictive-search]')) {
      const path = new URL(link.href, location.origin).pathname;
      const links = Array.from(predictive.querySelectorAll('[data-predictive-search] a'));
      publish('suggestion_click', {
        search_term: predictive.querySelector('input[type="search"]').value,
        result_type: path.includes('/products/') ? 'product' : path.includes('/collections/') ? 'collection' : path.includes('/blogs/') ? 'article' : 'page',
        result_path: path, result_title: (link.querySelector('.predictive-search__item-heading')?.textContent || link.textContent).trim().slice(0, 100),
        result_position: links.indexOf(link) + 1, contents_match: link.dataset.pdilContents === 'true'
      });
    } else if (link?.dataset.pdilContents === 'true') {
      publish('contents_click', {search_term: new URL(location.href).searchParams.get('q'), result_path: new URL(link.href).pathname, result_type: 'product', contents_match: true});
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[role="search"]')) return;
    queueMicrotask(() => { if (!event.defaultPrevented) publish('search_submit', {search_term: new FormData(event.target).get('q')}); });
  });
})();
